
import Mustache from 'mustache';
import React, { useContext, useEffect, useState } from 'react';
import { ArrowLeft, Calendar2DateFill, ChatDots, Link, MenuUp } from 'react-bootstrap-icons';
import { NavLink } from 'react-router-dom';
import Authentication from '../../../../libs/api/services/Authentication';
import Messaging from '../../../../libs/api/services/Messaging';
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider';
import MessageModal from '../../messaging/common/MessageModal';
import NewMessageModal from '../../messaging/management/components/new_message/NewMessageModal';
import DashboardContext from './DashboardProvider';

var _enable_timer = true
const animateCSSIn = (element, animation, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    // const node = document.querySelector(element);
    if (!element) resolve('Animation ended');
    const node = element;
    node.classList.remove(`d-none`);
    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      // node.classList.add(`d-none`);
      resolve('Animation ended');
    }

    if (!element) return
    node.addEventListener('animationend', handleAnimationEnd, { once: true });
  });
const animateCSSOut = (element, animation, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    if (!element) resolve('Animation ended');
    const animationName = `${prefix}${animation}`;
    // const node = document.querySelector(element);
    const node = element;

    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      node.classList.add(`d-none`);
      resolve('Animation ended');
    }

    if (!element) return
    node.addEventListener('animationend', handleAnimationEnd, { once: true });
  });
const animateCSSTransition = (element, animation, element2, animation2, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const animationName2 = `${prefix}${animation2}`;
    // const node = document.querySelector(element);
    if (!(element && element2)) {
      resolve('Animation ended');
      return
    }
    const node = element;
    const node2 = element2;
    node.classList.remove(`d-none`);
    node.classList.add(`${prefix}animated`, animationName);
    node.classList.add(`animate__faster`);
    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      node.classList.add(`d-none`);
      node2.classList.remove(`d-none`);
      node2.classList.add(`animate__faster`);
      node2.classList.add(`${prefix}animated`, animationName2);

      // node.classList.add(`d-none`);
      resolve('Animation ended');
    }


    node.addEventListener('animationend', handleAnimationEnd, { once: true });
  });

export default function DashboardWidgetMessages() {
  const { helpRefs, GlobalRef, createModal } = useContext(CommonFunctionsContext)
  const { results, setFilter } = useContext(DashboardContext)
  const [lastMessage, setLastMessage] = useState()
  const [active, setActive] = useState({
    dayOffset: undefined
  })
  const [notice, setNotice] = useState()

  useEffect(() => {
    if (Object.keys(helpRefs.current).includes('DashboardMessagesGroupBreakDown'))
      if (helpRefs.current &&
        Object.keys(helpRefs.current).includes('DashboardMessagesGroupBreakDown') &&
        Object.keys(helpRefs.current).includes('DashboardMessagesGroupMessages')
      ) {
        if (typeof active.dayOffset === 'undefined') {
          animateCSSTransition(helpRefs.current['DashboardMessagesGroupMessages'].current, 'fadeOutLeft', helpRefs.current['DashboardMessagesGroupBreakDown'].current, 'fadeInRight')
          // animateCSSIn(helpRefs.current['DashboardMessagesGroupBreakDown'].current, 'fadeInRight');
          // animateCSSOut(helpRefs.current['DashboardMessagesGroupMessages'].current, 'fadeOutLeft');
          _enable_timer = true
        } else {
          animateCSSTransition(helpRefs.current['DashboardMessagesGroupBreakDown'].current, 'fadeOutLeft', helpRefs.current['DashboardMessagesGroupMessages'].current, 'fadeInRight')
          // animateCSSIn(helpRefs.current['DashboardMessagesGroupMessages'].current, 'fadeInRight');
          // animateCSSOut(helpRefs.current['DashboardMessagesGroupBreakDown'].current, 'fadeOutLeft');
          _enable_timer = false
        }
      }
    setFilter('Messages', 'dayOffset', active.dayOffset)
  }, [active.dayOffset])

  useEffect(() => {
    // DashboardMessagesNotice
    if (notice && typeof notice !== 'undefined') {
      helpRefs.current['DashboardMessagesNotice'].current.innerHTML = notice
      animateCSSIn(helpRefs.current['DashboardMessagesNotice'].current, 'flipInX');
      setTimeout(() => { animateCSSOut(helpRefs.current['DashboardMessagesNotice'].current, 'flipOutY'); setNotice() }, 5000)
    }
  }, [notice])

  useEffect(() => {
    if (results && results.messages && results.messages.lastMessage) {
      if (results.messages.lastMessage !== lastMessage && lastMessage) {
        setNotice(`You have received a new message`)
      }
      setLastMessage(results.messages.lastMessage)
    }

    // setLastMessage
  }, [results])

  useEffect(() => {
    // console.log('Starting mailbox timer')
    const tmrID = setInterval(() => {
      // console.log('Checking Email ', _enable_timer)
      if (_enable_timer) {
        // console.log('Checking Email Trigger', tmrID, _enable_timer)
        Messaging.CheckEmail(Authentication.UserId())
        // console.warn('Re-enable check mail')
      }
    }, 1000 * 60 * 1)

    return () => {
      // console.log('Closing mailbox timer 1', tmrID)
      tmrID && clearInterval(tmrID)
    }
  }, [])

  const _handleCreateNewMessage = (e) => {
    createModal(<NewMessageModal />, 'New Message', undefined, () => { })
  }

  // <NewMessageComponent errors={(e) => setError(e)} onClose={() => setShowNewMessage(false)} />
  return (
    <div className={`col-lg-4 col-md-12 dashboard-card`} style={{ maxHeight: 'calc(50% - 0.5rem)', height: 'calc(50% - 0.5rem)' }}>
      <div className='text-center bg-secondary-container p-3 rounded h-100 d-flex flex-column h-100'>
        <div className=' '>
          <h3><ChatDots /> Messages</h3>
        </div>
        <div style={{ overflowY: 'auto', overflowX: 'hidden' }} className='flex-grow-1 d-flex flex-column justify-content-start align-items-start '>
          <div ref={r => GlobalRef(r, 'DashboardMessagesNotice')} className='d-none align-self-center'></div>
          {results && results.messages && results.messages.dailyBreakDown && <MessageDashboardNewMessageLineItemGroups active={active} setActive={setActive} counts={results.messages.dailyBreakDown} />}
        </div>
        <div className='flex-shrink-1'>
          <NavLink
            key={'nav-msgs'}
            className={"btn btn-sm"} tag={Link}
            to={'/Dashboard/Messages'}
          >
            <button className='btn btn-sm'><MenuUp className='me-2' />View All Messages</button>
          </NavLink>
          <button onClick={_handleCreateNewMessage} className='btn btn-sm'><MenuUp className='me-2' />Start a new message</button>
        </div>
      </div>
    </div>
  )
}
const MessageDashboardNewMessageLineItemGroups = ({ counts, active, setActive }) => {
  const { setFilter, filter, Queue } = useContext(DashboardContext)
  const { helpRefs, GlobalRef } = useContext(CommonFunctionsContext)

  const DaysFrom = (offSet, type) => {
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    if (type === 'Relative') {
      if (offSet === 0) return 'Today'
      if (offSet === 1) return 'Yesterday'
    }
    var date = new Date(Date.now() - (offSet * (3600 * 1000 * 24)))
    return weekday[date.getDay()]
  }

  const GROUPS = Array.from(new Array(7)).map((x, i) => { return { name: DaysFrom(i, 'Relative'), dayOffset: i } })
  // const GROUPS = [
  //   { name: 'Today', dayOffset: 0 },
  //   { name: 'Yesterday', dayOffset: 1 },
  //   { name: DaysFrom(2), dayOffset: 2 }
  // ]
  // const [active, setActive] = useState()

  const FindCounts = (daySub, type) => {
    var date = new Date(Date.now() - (daySub * (3600 * 1000 * 24)))
    const res = counts
      .find(x => x.status === type && x.date.substring(0, 10) === date.toISOString().substring(0, 10))
    return res ? res.count : 0
  }

  return (<>
    <div className='d-flex flex-grow-1 w-100 flex-column ' ref={r => GlobalRef(r, 'DashboardMessagesGroupBreakDown')}>
      {GROUPS.map(g => <button className='text-start d-flex w-100 btn mb-1 shadow ' onClick={e => setActive({ ...g })}>
        <div className='flex-grow-1 align-items-start'><Calendar2DateFill /> {g.name}</div>
        <div className='d-flex justify-content-end'>{FindCounts(g.dayOffset, 'Received')} Unread {FindCounts(g.dayOffset, 'Read')} Read</div>
      </button>)}
    </div>
    <div style={{ overflow: 'hidden' }} className='d-flex flex-grow-1 w-100 flex-column' ref={r => GlobalRef(r, 'DashboardMessagesGroupMessages')}>
      {typeof active.dayOffset !== 'undefined' &&
        <div className='d-flex flex-column h-100'>
          <div className='d-flex flex-column flex-shrink-1  bg-primary-section'>
            <div className='d-flex align-items-center'>
              <button className='btn btn-sm  bg-primary-button' onClick={e => setActive({ dayOffset: undefined })}><ArrowLeft /> </button>
              <div className='flex-grow-1 align-self-center'>{Queue.length > 0 ? 'Updating messages' : `Messages for ${active.name}`}</div>

            </div>
            <div className='d-flex shadow'>
              <button onClick={e => setFilter('Messages', 'Status', 'Received')} className={`btn btn-xs w-100 ${filter('Messages', 'Status') === 'Received' ? 'selected' : 'inactive'}`}>
                {`${filter('Messages', 'Status') === 'Received' ? 'Showing' : 'Show'} Unread`}</button>
              <button onClick={e => setFilter('Messages', 'Status', 'All')} className={`btn btn-xs w-100 ${filter('Messages', 'Status') === 'All' ? 'selected' : 'inactive'}`}>
                {`${filter('Messages', 'Status') === 'All' ? 'Showing' : 'Show'} All`}</button>
            </div>
          </div>
          <div className=' flex-grow-1' style={{ overflow: 'auto', height: '100%', maxHeight: '100%' }}>
            <MessagesForTheDay active={active} />
          </div>
        </div>
      }
    </div>
  </>)
}

const MessagesForTheDay = ({ active }) => {
  const { results, setFilter } = useContext(DashboardContext)
  // const [messages, setMessages] = useState()
  // useEffect(() => {
  //   const load = async () =>
  //     setMessages(await Dashboards.GetMessagesBreakDownForDay(dayOffset).catch(e => console.error('Failed to load messages for the day', e)))
  //   load()

  // }, [dayOffset])
  return (results && results.messages && results.messages.messages && results.messages.messages.length > 0 && results.messages.messages.map(m => <MessageDashboardNewMessageLineItem message={m} />))
}

const MessageDashboardNewMessageLineItem = ({ message }) => {
  const [details, setDetails] = useState()
  const [human, setHuman] = useState()
  const { createModal } = useContext(CommonFunctionsContext)

  useEffect(() => { if (message) setDetails(TheLoop(message, 'Message')) }, [message])
  /*
"Message|from": "Test"
 "Message|fromUser|emailAddress": "clinton@rootbranch.co.za"
 "Message|fromUser|firstName": "Clinton"
 "Message|fromUser|id": 4
 "Message|fromUser|idNumber": "9002015056085"
 "Message|fromUser|lastName": "Moss"
 "Message|fromUser|mobileNumber": "0825779793"
 "Message|fromUser|resetKey": "85e2f84c-a980-487c-9e57-b605554267c1"
 "Message|fromUser|title": ""
 "Message|fromUser|username": ""
 "Message|id": "d6e3be92-6c9a-4cbc-9df6-737ebd8eaf0a"
 "Message|messageType": "Outgoing"
 "Message|receviedDate": "2024-09-11T14:54:00"
 "Message|sentDate": "2024-09-11T14:54:00"
 "Message|serviceType|id": "e5b94b7f-f2a6-4d52-8d8d-766fc61a7d48"
 "Message|serviceType|type": "Email"
 "Message|subject": "Test"
 "Message|to": "Test"
 "Message|toUser|emailAddress": ""
 "Message|toUser|firstName": "Patient"
 "Message|toUser|id": 2
 "Message|toUser|idNumber": "patient"
 "Message|toUser|lastName": "Admin"
 "Message|toUser|mobileNumber": "+121231234"
 "Message|toUser|title": ""
 "Message|toUser|username": ""
  }*/

  const FancyHumanDT = (str) => {
    const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const ret = str
    if (!str) return 'Unknown Date/Time'
    var day = ''
    var time = ''
    // console.log('FancyHumanDT', new Date(str))
    var currentDateOnly = new Date()
    currentDateOnly.setHours(0)
    currentDateOnly.setMinutes(0)
    currentDateOnly.setSeconds(0)

    var inputDateOnly = new Date(ret)
    inputDateOnly.setHours(0)
    inputDateOnly.setMinutes(0)
    inputDateOnly.setSeconds(0)

    var inputTimeOnly = new Date(ret)

    const DaysDiff = Math.round((currentDateOnly - inputDateOnly) / (1000 * 60 * 60 * 24));

    if (DaysDiff === 0) {
      day = 'today'
      var seconds = (new Date().getTime() - inputTimeOnly.getTime()) / 1000
      var hourDiff = parseInt(((parseInt(seconds) / 60) / 60))
      var minDiff = parseInt((parseInt(seconds) / 60))
      var secDiff = parseInt(seconds)

      if (hourDiff > 1)
        day = `${hourDiff} hours ago`
      else if (hourDiff === 1)
        day = `an hours ago`
      else if (minDiff === 1)
        day = `a minute ago`
      else if (minDiff > 0)
        day = `${minDiff} minutes ago`
      else
        day = `${secDiff} seconds ago`
    }
    else if (DaysDiff === 1) {
      day = 'yesterday'
      time = ` at ${String(inputTimeOnly.getHours()).padStart(2, '0')}:${String(inputTimeOnly.getMinutes()).padStart(2, '0')}`
      // var seconds = (new Date().getTime() - inputTimeOnly.getTime()) / 1000
      // var hourDiff = parseInt(((parseInt(seconds) / 60) / 60))
      // var minDiff = parseInt((parseInt(seconds) / 60))
      // var secDiff = parseInt(seconds)

      // if (hourDiff > 1)
      //   day = `${hourDiff} hours ago`
      // else if (hourDiff === 1)
      //   day = `an hours ago`
      // else if (minDiff === 1)
      //   day = `a minute ago`
      // else if (minDiff > 0)
      //   day = `${minDiff} minutes ago`
      // else
      //   day = `${secDiff} seconds ago`
    }
    else if (DaysDiff > 1 && DaysDiff < 7) {
      day = `on ${WEEKDAYS[inputDateOnly.getDay()]}`;
      time = ` at ${String(inputTimeOnly.getHours()).padStart(2, '0')}:${String(inputTimeOnly.getMinutes()).padStart(2, '0')}`
    }
    else if (currentDateOnly.getFullYear() === inputDateOnly.getFullYear()) {
      day = `on ${WEEKDAYS[inputDateOnly.getDay()]} ${MONTHS[inputDateOnly.getMonth()]} ${inputDateOnly.getDate()}`;
      time = ` at ${String(inputTimeOnly.getHours()).padStart(2, '0')}:${String(inputTimeOnly.getMinutes()).padStart(2, '0')}`
    } else {
      day = `on ${WEEKDAYS[inputDateOnly.getDay()]} ${MONTHS[inputDateOnly.getMonth()]} ${inputDateOnly.getDate()} ${inputDateOnly.getFullYear()}`;
      time = ` at ${String(inputTimeOnly.getHours()).padStart(2, '0')}:${String(inputTimeOnly.getMinutes()).padStart(2, '0')}`
    }

    // console.log('FancyHumanDT', ret, currentDateOnly, inputDateOnly, inputDateOnly === currentDateOnly)
    // console.log('FancyHumanDT Offset', DaysDiff)

    return `${day} ${time}`
  }


  const PostFilter = (obj) => {
    obj['Message|sentDate'] = FancyHumanDT(obj['Message|sentDate'])
    return obj
  }
  useEffect(() => {
    if (details)
      setHuman(Mustache.render(`
    {{#Message|serviceType|type}}{{{.}}}{{/Message|serviceType|type}}
    {{#Message|fromUser|firstName}} from {{{.}}} {{Message|fromUser|lastName}}
    {{/Message|fromUser|firstName}}
    {{^Message|fromUser|firstName}} from 
    {{Message|from}}
    {{/Message|fromUser|firstName}}
    {{#Message|sentDate}} {{{.}}} {{/Message|sentDate}}
    {{#Message|subject}} regarding {{{.}}}{{/Message|subject}}
    `.replace(/\t|\n\s*|\r|\t/g, ""), PostFilter(details)))
  }, [details])


  const _handleShowMessage = () => {
    createModal(<MessageModal message={message} />, '', <ChatDots />)
  }

  return (<div className='my-2 bg-light text-dark small shadow p-1 rounded'>
    {/* {
      details &&
      <pre>
        {JSON.stringify(details, '\t', 2)}
      </pre>
    } */}
    <div>

      {human &&
        <>
          <div dangerouslySetInnerHTML={{ __html: human }} />
          <button onClick={e => _handleShowMessage()} className='btn btn-xs'>Show Message</button>
        </>
      }
      {/* <button className='btn btn-xs'>Mark as read</button> */}
    </div>
  </div>)
}

// Misc
const TheLoop = (props, parent) => {
  var res = {}

  if (Array.isArray(props)) {
    for (const o of props) {
      res = { ...res, ...TheLoop(o, parent) }
    }
  }
  else if (typeof props === 'object')
    for (const o of Object.keys(props)) {
      if (o === 'receivedFrom') {
        if (Array.isArray(props[o]) && isNaN(Object.keys(props[o][0]))) {
          res = {
            ...res,
            ...{ [parent + '|receivedFrom']: props[o].join(',') }
          }
        } else {
          res = {
            ...res,
            ...{ [parent + '|receivedFrom']: Object.keys(props[o]).join(',') }
          }
        }
      } else
        res = { ...res, ...TheLoop(props[o], parent + '|' + o) }
    }
  else {
    res[parent] = props
  }
  return res;
}